import { APIRoute } from '@/modules/utils'

export const Route: APIRoute = {
  method: 'DELETE',
  path: '/pictures/:pictureId',
}

export type Body = never

export type UrlParams = {
  pictureId: string
}

export type Response = never
